import type { HTMLAttributes } from 'react'
import { cn } from '../../utils.js'

export interface BetaBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** Size variant */
  size?: 'sm' | 'md'
}

/**
 * Beta badge pill indicator.
 * Coral-pale background with coral text, uppercase, rounded pill.
 * Used throughout the app during the beta period.
 */
export function BetaBadge({ size = 'md', className, ...props }: BetaBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-bold uppercase tracking-wider align-middle',
        'bg-[#ff6b4a15] text-[#ff6b4a]',
        size === 'sm'
          ? 'px-1.5 py-0.5 text-[0.55rem] tracking-[0.08em] ml-1.5'
          : 'px-2.5 py-0.5 text-[0.65rem] tracking-[0.08em] ml-2',
        className,
      )}
      {...props}
    >
      Beta
    </span>
  )
}
